const state = {
    requests: [],
};
const getters = {
    requests: (state) => state.requests,
    failedRequests: (state) => state.requests.filter(({customDebugInfo}) => customDebugInfo.status === 'failed'),
    doneRequests: (state) => state.requests.filter(({customDebugInfo}) => customDebugInfo.status === 'done'),
    pendingRequests: (state) => state.requests.filter(({customDebugInfo}) => customDebugInfo.status === 'pending'),
};
const actions = {};
const mutations = {
    addRequest: (state, request) => state.requests.push(request),
    addResponse: (state, response) => {
        state.requests = state.requests.map(request => {
            if(request.customDebugInfo.requestId === response.config.customDebugInfo.requestId) {
                request.customDebugInfo.status = 'done'
                return {
                    ...request,
                    response,
                }
            }
            return request
        });
    },
    addErrorResponse: (state, {config, message, request, response}) => {
        state.requests = state.requests.map(request => {
            if(request.customDebugInfo.requestId === config.customDebugInfo.requestId) {
                request.customDebugInfo.status = 'failed'
                request.customDebugInfo.errorMessage = message;
                return {
                    ...request,
                    response,
                }
            }
            return request
        });
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};